<template>
  <div class="my-6">
    <div class="d-flex p-3">
      <v-skeleton-loader class="mx-2" type="table-cell@3" />
    </div>
    <v-skeleton-loader type="list-item" />
  </div>
</template>

<script>
export default {
  name: 'TeamActivitySkeleton',
}
</script>
